import React, { useEffect, useState } from 'react';
import {
    CheckCircleSvg,
    ErrorSvg,
    InfoSvg,
    WarningSvg,
    CloseSvg
} from '../../svgFile';

import { messageEvents } from '../../utils/messageEvents';

const MessageBox = ({
    type = 'success',
    message,
    onClose,
    showIcon = true,
    showCloseButton = true,
    className = '',
    scrollToTop = false,
    autoHideDuration = 3000,
    zIndex = 9999
}) => {
    const [eventMessage, setEventMessage] = useState(null);
    const [eventType, setEventType] = useState('success');

    useEffect(() => {
        const unsubscribe = messageEvents.subscribe(
            (msgType, msg, duration = autoHideDuration) => {
                setEventType(msgType);
                setEventMessage(msg);

                if (duration > 0) {
                    setTimeout(() => {
                        setEventMessage(null);
                    }, duration);
                }
            }
        );

        return unsubscribe;
    }, [autoHideDuration]);


    const displayMessage = eventMessage || message;
    const displayType = eventMessage ? eventType : type;

    useEffect(() => {
        if (displayMessage && scrollToTop) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [displayMessage, scrollToTop]);

    if (!displayMessage) return null;

    const getIcon = () => {
        switch (displayType) {
            case 'success':
                return <CheckCircleSvg />;
            case 'error':
                return <ErrorSvg />;
            case 'warning':
                return <WarningSvg />;
            case 'info':
                return <InfoSvg />;
            default:
                return <CheckCircleSvg />;
        }
    };

    const handleClose = () => {
        setEventMessage(null);

        if (onClose) {
            onClose();
        }
    };
    const notifyClass = `notify-${displayType}`;
    const notifyIconClass = `notify-icon-${displayType}`;
    const notifyCloseClass = `notify-close-${displayType}`;

    return (
        <div
            className={`notify-container ${notifyClass} ${className}`}
            style={{ zIndex }}
        >
            {showIcon && (
                <div className={`notify-icon ${notifyIconClass}`}>
                    {getIcon()}
                </div>
            )}

            <div className="notify-message">
                {displayMessage}
            </div>

            {showCloseButton && (
                <button
                    className={`notify-close-btn ${notifyCloseClass}`}
                    onClick={handleClose}
                    aria-label="Close"
                >
                    <CloseSvg />
                </button>
            )}
        </div>
    );
};

export default MessageBox;